<template>
  <div>
    <label v-if="label" class="form-label">{{ label }}:</label>
    <div class="" :class="{ error: errors.length }">
        <input ref="file" type="file" :accept="accept" class="hidden" @change="change">
    </div>
    <div v-if="errors.length" class="text-danger">
        <small class="font-weight-bold">
            {{ errors[0] }}
        </small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: File,
    label: String,
    accept: String,
    errors: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    value(value) {
      if (!value) {
        this.$refs.file.value = ''
      }
    },
  },
  methods: {
    filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024))
      return (size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },
    browse() {
      this.$refs.file.click()
    },
    change(e) {
      this.$emit('input', e.target.files[0])
    },
    remove() {
      this.$emit('input', null)
    },
  },
}
</script>
